// src/ramda-adjunct/isNotNaN.ts
function isNotNaN(val) {
  return !Number.isNaN(val);
}
var isNotNaN_default = isNotNaN;

export {
  isNotNaN_default
};
//# sourceMappingURL=chunk-ZDTRL3MX.mjs.map